/* client/src/components/Admin/AdminPanel.tsx */
import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Tabs,
  Tab,
  Box,
  Paper,
  Alert,
  CircularProgress,
} from '@mui/material';
import BusinessUnits from './BusinessUnits';
import Materials from './Materials';
import ExpenseCategories from './ExpenseCategories';
import InvestmentTypes from './InvestmentTypes';
import Users from './Users'; // Add this import
import { apiVerifyAdmin } from '../../services/apiService';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function AdminPanel() {
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

 useEffect(() => {
    checkAdminAccess();
  }, []);

  const checkAdminAccess = async () => {
    try {
      setLoading(true);
      const response = await apiVerifyAdmin();
      setIsAdmin(true);
    } catch (err: any) {
      setError(err.message || 'Admin access denied');
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (!isAdmin) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Alert severity="error">{error || 'You do not have administrative privileges'}</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Administrative Panel
      </Typography>
      
      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="admin tabs">
            <Tab label="Users" /> {/* Add Users tab */}
            <Tab label="Business Units" />
            <Tab label="Materials" />
            <Tab label="Expense Categories" />
            <Tab label="Investment Types" />
          </Tabs>
        </Box>
        
        <TabPanel value={tabValue} index={0}>
          <Users /> {/* Add Users component */}
        </TabPanel>
        
        <TabPanel value={tabValue} index={1}>
          <BusinessUnits />
        </TabPanel>
        
        <TabPanel value={tabValue} index={2}>
          <Materials />
        </TabPanel>
        
        <TabPanel value={tabValue} index={3}>
          <ExpenseCategories />
        </TabPanel>
        
        <TabPanel value={tabValue} index={4}>
          <InvestmentTypes />
        </TabPanel>
      </Paper>
    </Container>
  );
}

export default AdminPanel;